import api from "./api";

export async function deleteAccount(password: string): Promise<void> {
  await api.post("/users/delete-account/", { password });
}
